import { useAccountContext } from '../useAccountContext';

export const useCompanyBillingEnabled = () => {
  const { currentCompany } = useAccountContext();

  return Boolean(currentCompany?.isBillingEnabled);
};
